import * as Sentry from '@sentry/react';

export type InspectionSubmitErrorKind = 'validation' | 'api';

export interface ReportInspectionSubmitErrorArgs {
  kind: InspectionSubmitErrorKind;
  message: string;
  homeInspectionJobId?: string;
  err?: unknown;
}

function axiosExtras(err: unknown): Record<string, unknown> {
  if (!err || typeof err !== 'object') return {};
  const e = err as {
    code?: string;
    message?: string;
    response?: { status?: number };
  };
  return {
    axios_code: e.code,
    axios_message: e.message,
    http_status: e.response?.status,
  };
}

function toError(err: unknown, message: string): Error {
  if (err instanceof Error) return err;
  return new Error(message);
}

export function reportInspectionSubmitError({
  kind,
  message,
  homeInspectionJobId,
  err,
}: ReportInspectionSubmitErrorArgs): void {
  const exception = kind === 'api' ? toError(err, message) : new Error(message);
  const httpStatus = axiosExtras(err).http_status;

  Sentry.captureException(exception, {
    tags: {
      module: 'home_services',
      feature: 'inspection_report_submit',
      error_kind: kind,
    },
    extra: {
      homeInspectionJobId,
      message,
      ...axiosExtras(err),
    },
    fingerprint:
      kind === 'validation'
        ? ['inspection_report_submit', 'validation', message]
        : ['inspection_report_submit', 'api', String(httpStatus ?? 'unknown'), message],
  });
}
